import { Avatar, Box, Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import {
  DELETE_CLIENT_TIMESHEET_TEMPLATES,
  FETCH_CLIENT_TIMESHEET_TEMPLATES_V2
} from "../../../constant/Apipath";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../../request/Postrequest";
import { BIGrey, BILightGrey } from "../../../assets/helpers";
import DeletConfirmModal from "../promptModal/DeletConfirmModal";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";
import Loader from "../../../common/Loader";

const CrewTemplateView = ({ isOpen, onClose, templateId, setModelState }) => {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;
  const [data, setData] = useState({});

  const [loader, setLoader] = useState(true);

  const {
    TEXT_TEMPLATE_EDIT,
    TEXT_JOB,
    TEXT_ACTIVITIES,
    TEXT_EMPLOYEES,
    TEXT_CREATE_TIMESHEET,
    TEXT_DELETE_TIMESHEET,
    TEXT_DELETE_TEMPLATE
  } = ClientEnglishFallback?.CrewTemplateView(multiLanguageData?.CrewTemplateView || {});

  const { TEXT_ACTION_BE_UNDONE } = ClientEnglishFallback?.DeletConfirmModal(
    multiLanguageData?.DeletConfirmModal || {}
  );

  const [deletConfirmModal, setDeletConfirmModal] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchTimesheetTemplates();
    }
  }, [isOpen]);

  // API Functions
  const fetchTimesheetTemplates = async () => {
    try {
      const fetchParams = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: false,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientEmployeeId: selectedClientData?.ClientEmployeeId,
            id: templateId
          }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_CLIENT_TIMESHEET_TEMPLATES_V2,
        fetchParams,
        TOKEN
      );
      if (getResponse.status === 200) {
        setData(getResponse?.data?.data[0] ?? {});
      }
    } catch (error) {
      console.error("fetchTimesheetTemplates-> Error fetching timesheet templates: ", error);
    } finally {
      setLoader(false);
    }
  };

  const onCreateTimesheet = () => {
    setModelState("CREW");
  };

  const onDeleteTemplate = () => {
    setDeletConfirmModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      // PAYLOAD :
      const delete_object = {
        UserId: USER_ID,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [
          {
            Id: templateId
          }
        ]
      };
      // API CALL :
      const res = await Postrequestcall(DELETE_CLIENT_TIMESHEET_TEMPLATES, delete_object, TOKEN);
      if (res.status === 201) {
        setDeletConfirmModal(false);
        onClose();
      }
    } catch (e) {
      console.log("handleDeleteConfirm-> Error When Deleting Client Timesheet Template: ", e);
    }
  };

  return (
    <>
      <DeletConfirmModal
        isOpen={deletConfirmModal}
        onClose={() => setDeletConfirmModal(false)}
        onConfirm={() => handleDeleteConfirm()}
        heading={TEXT_DELETE_TEMPLATE}
        title={TEXT_ACTION_BE_UNDONE}
      />

      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={{
            maxWidth: "450px",
            padding: {
              xs: "10px",
              xl: "15px",
              lg: "15px",
              md: "15px",
              sm: "10px"
            }
          }}
          className="client-modal-responsive">
          {loader ? (
            <Stack
              alignItems={"center"}
              minHeight={"300px"}
              justifyContent={"center"}
              width={"100%"}>
              <Loader />
            </Stack>
          ) : (
            <>
              <Stack
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                flexDirection={"row"}>
                <>
                  <Stack
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    width={"100%"}>
                    <Typography variant="h6">{data?.name}</Typography>
                    <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                      <Typography
                        color="error"
                        variant="h6"
                        style={{ cursor: "pointer" }}
                        onClick={() => setModelState("EDIT_TEMPLATE")}>
                        {TEXT_TEMPLATE_EDIT}
                      </Typography>
                      <IconButton size="small" onClick={onClose}>
                        <CloseIcon />
                      </IconButton>
                    </Stack>
                  </Stack>
                </>
              </Stack>
              <Stack marginTop={"10px"} gap={"5px"}>
                <Typography color={BIGrey}>{TEXT_JOB}</Typography>
                <Typography>{data?.clientJobCode + "-" + data?.clientJobName}</Typography>
              </Stack>
              <Stack marginTop={"10px"} gap={"5px"}>
                <Typography color={BIGrey}>
                  {TEXT_ACTIVITIES} ({data.templateActivitiesList?.length})
                </Typography>
                {data?.templateActivitiesList?.map((item) => (
                  <Typography>{item?.activityCode + "-" + item?.activityName}</Typography>
                ))}
              </Stack>
              <Stack marginTop={"10px"} gap={"5px"}>
                <Typography color={BIGrey}>
                  {TEXT_EMPLOYEES} ({data.templateEmployeesList?.length})
                </Typography>
                {data?.templateEmployeesList?.map((item) => (
                  <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                    <Avatar alt={item?.clientEmployeeName} src={item?.userProfilePicture} />
                    <Typography>{item?.clientEmployeeName}</Typography>
                  </Stack>
                ))}
              </Stack>
              <Stack gap={"10px"} marginTop={"15px"}>
                <Button
                  sx={{
                    backgroundColor: CLIENT_ACCENT_COLOR,
                    color: "white",
                    borderRadius: "10px",
                    textTransform: "none"
                  }}
                  onClick={() => onCreateTimesheet()}>
                  {TEXT_CREATE_TIMESHEET}
                </Button>
                <Button
                  sx={{
                    backgroundColor: BILightGrey,
                    color: "#000",
                    borderRadius: "10px",
                    textTransform: "none"
                  }}
                  onClick={() => onDeleteTemplate()}>
                  {TEXT_DELETE_TIMESHEET}
                </Button>
              </Stack>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default CrewTemplateView;
